(() => {
  'use strict';
  if (window.vrWishlist) return;
  const key = 'vrshop:favorites';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const parse = value => {
    try { const saved = JSON.parse(value || '[]'); return Array.isArray(saved) ? [...new Set(saved.filter(validHandle))].slice(0,500) : []; }
    catch (_) { return []; }
  };
  let favorites = [];
  let canSave = true;
  try { favorites = parse(localStorage.getItem(key)); } catch (_) { canSave = false; }
  const dialog = document.getElementById('vr-wishlist');
  if (!dialog) return;
  const list = dialog.querySelector('[data-vr-wishlist-items]');
  const empty = dialog.querySelector('[data-vr-wishlist-empty]');
  const message = dialog.querySelector('[data-vr-wishlist-message]');
  const announce = document.querySelector('[data-vr-wishlist-announcement]');
  const template = document.getElementById('vr-wishlist-item-template');
  const cache = new Map();
  let opener;
  let renderId = 0;
  const root = dialog.dataset.productsRoot.replace(/\/?$/, '/');
  const productUrl = handle => `${root}products/${encodeURIComponent(handle)}`;
  const counts = () => {
    document.querySelectorAll('[data-vr-wishlist-count],[data-vr-wishlist-total]').forEach(node => { node.textContent = favorites.length; });
    document.querySelectorAll('[data-vr-wishlist-open]').forEach(button => button.setAttribute('aria-label', `Abrir lista de deseos, ${favorites.length} ${favorites.length === 1 ? 'producto' : 'productos'}`));
  };
  const refresh = () => {
    document.querySelectorAll('[data-vr-favorite]').forEach(button => {
      const selected = favorites.includes(button.dataset.vrFavorite);
      const action = selected ? 'Quitar de mi lista de deseos' : 'Añadir a mi lista de deseos';
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${action}: ${button.dataset.vrProductTitle || button.dataset.vrFavorite}`);
      const tooltip = button.querySelector('.vr-wish-tooltip');
      if (tooltip && tooltip.textContent !== action) tooltip.textContent = action;
    });
    counts();
  };
  const fetchProduct = handle => {
    if (cache.has(handle)) return cache.get(handle);
    const promise = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${productUrl(handle)}.js`, {signal:controller.signal, credentials:'same-origin'});
        if (response.status === 404) return {removed:true};
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        if (!product.title || !Array.isArray(product.variants)) throw new Error('Invalid product');
        return product;
      } finally { clearTimeout(timeout); }
    })();
    cache.set(handle,promise);
    promise.catch(() => cache.delete(handle));
    return promise;
  };
  const rowFor = handle => {
    const row = template.content.firstElementChild.cloneNode(true);
    row.dataset.wishHandle = handle;
    const url = productUrl(handle);
    row.querySelectorAll('[data-wish-image-link],[data-wish-name],[data-wish-view]').forEach(link => { link.href=url; });
    const name = row.querySelector('[data-wish-name]');
    name.textContent = handle.replaceAll('-',' ');
    row.querySelector('[data-wish-price]').textContent='Cargando prenda…';
    const remove = row.querySelector('[data-wish-remove]');
    remove.dataset.vrFavorite = handle;
    remove.setAttribute('aria-label','Quitar de mi lista de deseos');
    row.querySelector('[data-wish-retry]').dataset.wishRetry = handle;
    return row;
  };
  const fillRow = async (row,handle,id) => {
    try {
      const product = await fetchProduct(handle);
      if (id !== renderId || !row.isConnected) return;
      const name = row.querySelector('[data-wish-name]');
      const price = row.querySelector('[data-wish-price]');
      if (product.removed) {
        price.textContent='Esta prenda ya no está disponible.';
        row.querySelector('[data-wish-view]').hidden=true;
        row.querySelector('[data-wish-image-link]').hidden=true;
        return;
      }
      name.textContent=product.title;
      row.querySelector('[data-wish-remove]').dataset.vrProductTitle=product.title;
      row.querySelector('[data-wish-remove]').setAttribute('aria-label',`Quitar de mi lista de deseos: ${product.title}`);
      const currency=window.Shopify?.currency?.active || 'COP';
      const launchConfig = JSON.parse(document.getElementById('vr-launch-prices')?.textContent || '{}');
      const launch = launchConfig.enabled ? launchConfig.prices?.[product.handle] : null;
      const displayPrice = launch && product.price === launch[0] ? launch[1] : product.price;
      price.textContent=new Intl.NumberFormat('es-CO',{style:'currency',currency,maximumFractionDigits:0}).format(displayPrice/100)+(currency === 'COP' ? ' COP' : '')+(!product.available ? ' · Agotado' : '');
      const installment=row.querySelector('[data-wish-installments]');
      if (installment && Number.isFinite(displayPrice) && displayPrice > 0) {
        const amount=new Intl.NumberFormat('es-CO',{style:'currency',currency,maximumFractionDigits:currency === 'COP' ? 0 : 2}).format(currency === 'COP' ? Math.floor(displayPrice/300) : displayPrice/300).replace(/[\u00a0\u202f]/g,'');
        installment.querySelector('[data-wish-installment-amount]').textContent=amount;
        installment.hidden=false;
      }
      const img=document.createElement('img');
      img.width=100;img.height=134;img.loading='lazy';
      const image=product.featured_image || product.images?.[0];
      if (image) {
        const imageUrl=new URL(image,location.origin);
        if (imageUrl.protocol === 'https:') { imageUrl.searchParams.set('width','240'); img.src=imageUrl.href; img.alt=product.title; row.querySelector('[data-wish-image-link]').append(img); }
      }
    } catch (_) {
      if (id !== renderId || !row.isConnected) return;
      row.querySelector('[data-wish-price]').textContent='No pudimos cargar esta prenda. Sigue guardada en tu lista.';
      row.querySelector('[data-wish-retry]').hidden=false;
    }
  };
  const render = async () => {
    const id=++renderId;
    list.replaceChildren();
    empty.hidden=favorites.length>0;
    message.textContent=canSave ? '' : 'Este navegador no permite guardar tu selección. Se conservará solo mientras tengas esta página abierta.';
    const pending=favorites.map(handle=>{const row=rowFor(handle);list.append(row);return {handle,row};});
    let next=0;
    await Promise.all(Array.from({length:Math.min(4,pending.length)},async()=>{
      while(next<pending.length && id===renderId){const {handle,row}=pending[next++];await fillRow(row,handle,id);}
    }));
  };
  const toggle = handle => {
    if (!validHandle(handle)) return;
    // Read the latest value so a second tab cannot overwrite a recent selection.
    if(canSave) { try { favorites=parse(localStorage.getItem(key)); } catch (_) {canSave=false;} }
    const adding=!favorites.includes(handle);
    favorites=adding ? [...favorites,handle] : favorites.filter(item=>item!==handle);
    try {localStorage.setItem(key,JSON.stringify(favorites));} catch (_) {canSave=false;}
    refresh();
    announce.textContent=canSave ? (adding ? 'Prenda añadida a tu lista de deseos.' : 'Prenda quitada de tu lista de deseos.') : 'La selección está disponible en esta página, pero este navegador no permite guardarla.';
    if(dialog.open) {render();dialog.querySelector('[data-vr-wishlist-close]').focus();}
  };
  const close = () => dialog.close();
  document.addEventListener('click',event=>{
    const target=event.target;
    if (!(target instanceof Element)) return;
    const favorite=target.closest('[data-vr-favorite]');
    if(favorite){event.preventDefault();event.stopPropagation();toggle(favorite.dataset.vrFavorite);return;}
    const trigger=target.closest('[data-vr-wishlist-open]');
    if(trigger){event.preventDefault();opener=trigger;refresh();render();dialog.showModal();document.documentElement.classList.add('vr-wishlist-open');return;}
    if(target.closest('[data-vr-wishlist-close]')){close();return;}
    const retry=target.closest('[data-wish-retry]');
    if(retry){cache.delete(retry.dataset.wishRetry);render();dialog.querySelector('[data-vr-wishlist-close]').focus();}
  });
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)close();
  });
  dialog.addEventListener('close',()=>{document.documentElement.classList.remove('vr-wishlist-open');opener?.focus();});
  window.addEventListener('storage',event=>{if(event.key===key || event.key===null){favorites=parse(event.newValue);refresh();if(dialog.open)render();}});
  document.addEventListener('shopify:section:load',refresh);
  let queued=false;
  new MutationObserver(records=>{
    if(!records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches?.('[data-vr-favorite],[data-vr-wishlist-count]') || node.querySelector?.('[data-vr-favorite],[data-vr-wishlist-count]')))))return;
    if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;refresh();});}
  }).observe(document.body,{childList:true,subtree:true});
  window.vrWishlist={refresh};
  refresh();
})();
